app.component('recipeDetail', {
    templateUrl: 'app/recipe/recipe_detail.html',
    controller: function ($window, $location, $routeParams, recipeInfo) {
        var $ctrl = this;
        $ctrl.$onInit = function () {
            $ctrl.recipeInfo = recipeInfo.getRecipe($routeParams.recipeid);
            $ctrl.selectedTabIndex = $routeParams.tabIndex;
        };
    }
});
